<header class="shadow">
  <nav class="navbar navbar-light bg-white navbar-expand-lg navbar-link-underline" aria-label="Main Navbar">
    <div class="container-fluid">
      <!-- hamburger button -->
      <button class="navbar-toggler m-0 me-4" (click)="openMainNav(offcanvasMobileNav)" type="button">
        <span class="material-icons-round icon-lg">menu</span>
      </button>
      <!-- logo -->
      <a class="navbar-brand navbar-logo" (click)="navigateToLandingDefault()">
        <img alt="Labcorp | Payer" class="branding" src="assets/public/images/logo-payer-color.png" />
      </a>

      <div class="d-flex flex-row">
        <button type="button" name="toggleUserNavigation" aria-label="Toggle User Navigation"
          class="navbar-toggler d-lg-none m-0" (click)="openUserNav(offcanvasUserNav)">
          <span class="badge badge-username m-0">{{badgeUserName}}</span>
        </button>
        <!-- NOTIFICATIONS -->
        <ul *ngIf="sideBarNotifications.length" class="navbar-nav p-0 m-0 d-none d-lg-block">
          <li class="nav-item" ngbDropdown #myDrop="ngbDropdown">
            <a class="nav-link" [ngClass]="{'dropdown-toggle':false}" tabindex="0" ngbDropdownToggle
              id="navbarNotificationDropdown" role="button">
              <i class="material-icons-round icon">notifications_active</i><span class="d-none"> Notifications</span>
            </a>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end" style="min-width:20rem;">
              <h6 class="dropdown-header d-none d-md-block">Notifications</h6>
              <div class="dropdown-divider d-none d-md-block"></div>
              <div *ngFor="let notification of sideBarNotifications">
                <div class="px-5">
                  <div class="d-flex flex-row">
                    <div class="d-flex">
                      <i class="material-icons-round {{notification.iconStyle}} mr-2">{{notification.icon}}</i>
                    </div>
                    <div [innerHtml]="notification.message"></div>
                  </div>
                </div>
                <div class="dropdown-divider"></div>
              </div>
              <div class="px-5">
                <a routerLink="/portal/results/search-results" (click)="isNavbarCollapsed = true; myDrop.close()">
                  <u>View all search results</u>
                </a>
              </div>
            </div>
          </li>
        </ul>
        <!-- USER PREFERENCE -->
        <ul class="navbar-nav me-0 d-none d-lg-block">
          <li ngbDropdown class="nav-item me-0">
            <a class="nav-link" ngbDropdownToggle role="button" tabindex="0">
              <span class="badge badge-username">{{badgeUserName}}</span>
              <span class="nav-link-wrapper" [attr.data-label]="userName">
                <span class="nav-link-label">{{userName}}</span>
              </span>
            </a>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end position-absolute">
              <a *ngIf="user && user.allowSearch" class="dropdown-item" type="button"
                routerLink="/portal/preferences/user-preferences" (click)="isResultsSubnavCollapsed = true"><em
                  class="material-icons-round">settings</em> Preferences</a>

              <a *ngIf="user" class="dropdown-item" type="button" routerLink="/portal/help"
                (click)="isResultsSubnavCollapsed = true"><em class="material-icons-round">help</em> Help</a>

              <div *ngIf="user && user.allowSearch" class="dropdown-divider"></div>
              <a class="dropdown-item" type="button" routerLink="/" (click)="signOut()"><em
                  class="material-icons-round">exit_to_app</em>Sign Out</a>
            </div>
          </li>
        </ul>

      </div>

    </div>
  </nav>
</header>

<!-- Offcanvas: Mobile Menu -->
<ng-template #offcanvasMobileNav let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-main-nav">Labcorp | Payer</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close"
      (click)="offcanvas.dismiss('Cross click')"></button>
  </div>

  <div class="offcanvas-body m-0 p-0">
    <div class="sidebar sidebar-dark">
      <ul class="nav flex-column p-0">
        <!--  Lab Results -->
        <li class="nav-item" *ngIf="user && user.allowSearch">
          <a class="nav-link d-flex justify-content-between align-items-center"
            [ngClass]="{active: !isResultsSubnavCollapsed, inactive: isResultsSubnavCollapsed }"
            (click)="isResultsSubnavCollapsed = !isResultsSubnavCollapsed">
            <span class="material-icons-round icon pe-4">science</span><span class="flex-fill">Lab Results</span><span
              class="flex-fill"></span>
            <span class="material-icons-round"
              [ngClass]="{'d-none': !isResultsSubnavCollapsed, 'd-inline-block': isResultsSubnavCollapsed}">chevron_right</span>
            <span class="material-icons-round"
              [ngClass]="{'d-inline-block': !isResultsSubnavCollapsed, 'd-none': isResultsSubnavCollapsed}">expand_more</span>
          </a>
          <div [ngbCollapse]="isResultsSubnavCollapsed" (click)="offcanvas.dismiss('Menu click')">
            <ul class="nav sidebar-subnav flex-column">
              <li class="nav-item">
                <a routerLink="/portal/results/search" class="small nav-link active" routerLinkActive="active"
                  (click)="toggleOnResultsNav()">Search</a>
              </li>
              <li *ngIf="user && user.isLCAAdmin" class="nav-item">
                <a routerLink="/portal/results/global-search" class="small nav-link" routerLinkActive="active"
                  (click)="toggleOnResultsNav()">Global Search</a>
              </li>
              <li class="nav-item">
                <a id="left-nav-save-searches" routerLink="/portal/results/saved-searches" class="small nav-link"
                  routerLinkActive="active" (click)="toggleOnResultsNav()">Saved Searches</a>
              </li>
              <li class="nav-item">
                <a routerLink="/portal/results/search-results" class="small nav-link" routerLinkActive="active"
                  (click)="toggleOnResultsNav()">Search Results</a>
              </li>
            </ul>
          </div>
        </li>

        <!-- single menu -->
        <li class="nav-item" *ngFor="let navItem of mainNav" (click)="offcanvas.dismiss('Menu click')">
          <a *ngIf="isShowMenu(navItem)" routerLink="{{ navItem.route }}" routerLinkActive="active"
            class="nav-link d-flex justify-content-between align-items-center" (click)="closeAllSubNavs()">
            <span class="material-icons-round icon">{{ navItem.iconName }}</span>
            <span class="flex-fill px-4">{{ navItem.title }}</span>
          </a>
        </li>

        <!--  Labcorp Gaps in Care -->
        <li class="nav-item" *ngIf="user && user.isGapsInCareUser">
          <a class="nav-link d-flex justify-content-between align-items-center"
            [ngClass]="{active: !isGICSubnavCollapsed, inactive: isGICSubnavCollapsed}"
            (click)="isGICSubnavCollapsed = !isGICSubnavCollapsed">
            <span class="material-icons-round icon pe-4">alternate_email</span>
            <span class="flex-fill">Gaps in Care</span>
            <span class="material-icons-round"
              [ngClass]="{'d-none': !isGICSubnavCollapsed,'d-inline-block': isGICSubnavCollapsed}">chevron_right</span>
            <span class="material-icons-round"
              [ngClass]="{'d-inline-block': !isGICSubnavCollapsed,'d-none': isGICSubnavCollapsed}">expand_more</span>
          </a>
          <div [ngbCollapse]="isGICSubnavCollapsed" (click)="offcanvas.dismiss('Menu click')">
            <ul class="nav sidebar-subnav flex-column">
              <li class="nav-item">
                <a routerLink="/portal/analytic-reports/gaps-in-care/status" class="small nav-link"
                  routerLinkActive="active" (click)="toggleOnGICNav();">Status</a>
              </li>

              <li class="nav-item">
                <a routerLink="/portal/analytic-reports/gaps-in-care/downloads" class="small nav-link"
                  routerLinkActive="active" (click)="toggleOnGICNav()">Downloads</a>
              </li>

              <li class="nav-item">
                <a routerLink="/portal/analytic-reports/gaps-in-care" class="small nav-link" routerLinkActive="active"
                  (click)="toggleOnGICNav()">Results</a>
              </li>
            </ul>
          </div>
        </li>

        <!-- Insight Analytics -->
        <li class="nav-item">
          <a *ngIf="user && user.isInsightAnalyticUser" routerLink="/portal/analytic-reports/insight-analytics"
            routerLinkActive="active" class="nav-link d-flex justify-content-between align-items-center"
            (click)="offcanvas.dismiss('Menu click')">
            <span class="material-icons-round icon">analytics</span>
            <span class="flex-fill px-4">Insight Analytics</span>
          </a>
        </li>
      </ul>
      <!-- NOTIFICATIONS -->
      <ul *ngIf="sideBarNotifications.length" class="navbar-nav">
        <li class="nav-item" ngbDropdown #myDrop="ngbDropdown">
          <a class="nav-link" [ngClass]="{'dropdown-toggle':false}" tabindex="0" ngbDropdownToggle
            id="navbarNotificationDropdown" role="button">
            <i class="material-icons-round icon">notifications_active</i><span
              class="flex-fill px-4 d-lg-none">Notifications</span></a>

          <div ngbDropdownMenu class="dropdown-menu-right" style="min-width:20rem;">
            <h6 class="dropdown-header d-none d-md-block">Notifications</h6>
            <div class="dropdown-divider d-none d-md-block"></div>
            <div *ngFor="let notification of sideBarNotifications">
              <div class="px-5">
                <div class="d-flex flex-row">
                  <div class="d-flex">
                    <i class="material-icons-round {{notification.iconStyle}} me-2">{{notification.icon}}</i>
                  </div>
                  <div [innerHtml]="notification.message"></div>
                </div>
              </div>
              <div class="dropdown-divider"></div>
            </div>
            <div class="px-5">
              <a routerLink="/portal/results/search-results"
                (click)="offcanvas.dismiss('Menu click'); closeAllSubNavs(); myDrop.close()">
                <u>View all search results</u>
              </a>
            </div>
          </div>
        </li>
      </ul>

    </div>
  </div>
</ng-template>

<!-- Offcanvas: UserNav -->
<ng-template #offcanvasUserNav let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-user-nav">{{userName}}</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close"
      (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body m-0 p-0">
    <div class="sidebar sidebar-dark">
      <ul class="nav flex-column p-0">
        <li class="nav-item" (click)="offcanvas.dismiss('Menu click')">
          <a *ngIf="user && user.allowSearch" class="nav-link d-flex justify-content-between align-items-center"
            type="button" routerLink="/portal/preferences/user-preferences">
            <span class="flex-fill"><em class="material-icons-round">settings</em> Preferences</span></a>
          
           <a *ngIf="user" class="nav-link d-flex justify-content-between align-items-center"
            type="button" routerLink="/portal/help">
            <span class="flex-fill"><em class="material-icons-round">help</em> Help</span></a>

          <div *ngIf="user && user.allowSearch" class="dropdown-divider"></div>
          <a (click)="signOut()" class="nav-link d-flex justify-content-between align-items-center">
            <span class="flex-fill"><em class="material-icons-round">exit_to_app</em> Sign Out</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>